export default __webpack_public_path__ + "static/media/bird.991fa7ea.jpg";